const tryAndBuyAccountNumberStyle = () => ({
	accountNumber: {
		width: '300px',
		borderBottomColor: 'rgba(0, 0, 0, 0.65)',
		borderBottomStyle: 'solid',
		borderBottomWidth: '1px',
	},
});

export default tryAndBuyAccountNumberStyle;
